// Stock video-cover thumbnails available in the "Choose a cover" palette
// when uploading an instructional video. Not PHI, not per-org — public
// stock images served from the branding CDN
// (tl-dev-branding-*.s3 → assets.dev.therapylake.com).
//
// Object storage is `s3://tl-dev-branding/video-defaults/*.png`. The
// URLs below reference the CloudFront distribution — permanent,
// cache-friendly (Cache-Control: public, max-age=31536000, immutable
// set at upload time). No signed URL needed; these are meant to be
// hot-linked.
//
// The `defaultImage: true` code path in the video-upload flow stores
// one of these palette entries verbatim on Goal.instructions[].backgroundImage
// (the backend loosens ValidateNested on that field for exactly this
// reason — see api/src/videos/dto/videos.dto.ts). The video-complete
// tenant-prefix assertion is skipped when defaultImage=true because
// these keys legitimately don't have an orgId prefix — they're shared
// global assets.
//
// If you add a new stock cover:
//   1. aws s3 cp <local>.png s3://tl-dev-branding-<accountId>/video-defaults/<n>.png \
//        --content-type "image/png" --cache-control "public, max-age=31536000, immutable"
//   2. Add an entry below.
//   3. Do the equivalent upload on the prod branding bucket
//      (assets.therapylake.com) so the palette works there too.
const VIDEO_DEFAULT_BASE = 'https://assets.dev.therapylake.com/video-defaults';

export const videoDefaultImages = [
    {
        url: `${VIDEO_DEFAULT_BASE}/video-default-1.png`,
        key: 'video-defaults/video-default-1.png',
        name: 'video-default-1.png',
        originalName: 'video-default-1.png',
    },
    {
        url: `${VIDEO_DEFAULT_BASE}/video-default-2.png`,
        key: 'video-defaults/video-default-2.png',
        name: 'video-default-2.png',
        originalName: 'video-default-2.png',
    },
    {
        url: `${VIDEO_DEFAULT_BASE}/video-default-3.png`,
        key: 'video-defaults/video-default-3.png',
        name: 'video-default-3.png',
        originalName: 'video-default-3.png',
    },
    {
        url: `${VIDEO_DEFAULT_BASE}/video-default-4.png`,
        key: 'video-defaults/video-default-4.png',
        name: 'video-default-4.png',
        originalName: 'video-default-4.png',
    },
    {
        url: `${VIDEO_DEFAULT_BASE}/video-default-5.png`,
        key: 'video-defaults/video-default-5.png',
        name: 'video-default-5.png',
        originalName: 'video-default-5.png',
    },
];

export const videoStatusEnums = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    FAILED: 'FAILED',
};

// Legacy chunk size — kept for now in case something still references it.
// The new direct-S3 multipart flow uses MULTIPART_PART_SIZE from
// client/src/store/index.js (10 MB) instead.
export const CHUNK_SIZE = 10 * 1024 * 1024;
